import script from "./popup-component.vue?vue&type=script&setup=true&lang=js"
export * from "./popup-component.vue?vue&type=script&setup=true&lang=js"

import "./popup-component.vue?vue&type=style&index=0&id=392fb3a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392fb3a5"]])

export default __exports__